import { categories } from '@/mocks/home';

export default function CategoryCloud() {
  return (
    <section id="categories" className="bg-background-100 border-t border-foreground-950/10 scroll-mt-16">
      <div className="px-4 md:px-8 py-12 md:py-14">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <p className="text-xs tracking-[0.25em] text-accent-700 font-label">EXPLORE · 分类速览</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              按类型快速找片
            </h2>
          </div>
          <p className="text-xs text-foreground-500">共收录 8 个分类 · 729 部资源</p>
        </div>

        <div className="mt-7 flex flex-wrap gap-3">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href="#hot"
              className="group inline-flex items-center gap-2 rounded-full border border-foreground-950/12 bg-background-50 px-4 py-2 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="text-sm text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="font-label text-xs text-foreground-400">{cat.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}